module.exports = __webpack_public_path__ + "1c4ecada344b6247f80e7110574e89cb.MP3";